import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import adminEn from './locales/en/admin.json';
import adminAr from './locales/ar/admin.json';
import shopEn from './locales/en/shop.json';
import shopAr from './locales/ar/shop.json';

const resources = {
    en: {
        admin: adminEn,
        shop: shopEn,
    },
    ar: {
        admin: adminAr,
        shop: shopAr,
    },
};

// Retrieve saved language or default to en
const savedLang = localStorage.getItem('adminLanguage') || 'en';

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: savedLang,
        fallbackLng: 'en',
        ns: ['admin'],
        defaultNS: 'admin',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

// Handle RTL/LTR direction when language changes
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('adminLanguage', lng);
    document.documentElement.dir = i18n.dir();
    document.documentElement.lang = lng;
});

// Set initial direction
document.documentElement.dir = i18n.dir();
document.documentElement.lang = i18n.language;

export default i18n;
